import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

const IMAGE_SIZE = 40;
const MORE_LABEL_SIZE = 40;

/**
 * A class with style.
 */
export default class ProductCardVariantsStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options object.
	 * @param options.theme Theme.
	 * @returns Styles.
	 */
	public static getStyle(options: { theme: ITheme }): string {
		const { spacing, color, border } = options.theme;
		return css`
			:host {
				display: block;
			}

			.container {
				display: flex;
				flex-flow: wrap;
				align-items: center;
				padding: 0;
				margin: 0;
				justify-content: flex-start;
			}

			li {
				list-style-type: none;
			}

			button {
				background: none;
				color: inherit;
				border: none;
				margin: 0;
				font: inherit;
				cursor: pointer;
				outline: inherit;
			}

			.variant {
				width: ${IMAGE_SIZE / 16}rem;
				height: ${IMAGE_SIZE / 16}rem;
				cursor: pointer;
				list-style-type: none;
				outline: none;
				margin-top: ${spacing.space25 / 16}rem;
				box-shadow: 0 0 0 ${1 / 16}rem transparent;
				border-radius: ${border.radius.radius4 / 16 / 2}rem;
				padding: ${spacing.space25 / 2 / 16}rem;
			}

			.variant:focus {
				box-shadow: 0 0 0 ${1 / 16}rem ${color.border.default};
			}

			.variant:hover {
				box-shadow: 0 0 0 ${1 / 16}rem ${color.border.default};
			}

			.divider {
				width: ${spacing.space25 / 16}rem;
			}

			.showMoreButton {
				background-color: ${color.background.default};
				cursor: pointer;
				border: ${border.thickness.thin / 16}rem solid ${color.border.light};
				margin: ${spacing.space25 / 2 / 16}rem;
				margin-top: ${spacing.space25 / 16}rem;
				width: ${MORE_LABEL_SIZE / 16}rem;
				height: ${MORE_LABEL_SIZE / 16}rem;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.showMoreButton:hover {
				border-color: ${color.border.default};
			}

			.visuallyHidden:not(:focus):not(:active) {
				clip: rect(0 0 0 0);
				clip-path: inset(50%);
				height: ${1 / 16}rem;
				overflow: hidden;
				position: absolute;
				white-space: nowrap;
				width: ${1 / 16}rem;
			}
		`;
	}
}
